import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Table,
} from "react-bootstrap";
import { useMediaQuery } from "react-responsive";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { AuthContext, ThemeContext } from "../../../auth";
import { HeaderWeb, SidebarComponent } from "../../../components";
import { FaInfoCircle } from "react-icons/fa";
import { ModalDetailPcpSewa, ModalUbahLead } from "../../../components/Modal";
import { axiosAuth } from "../../../api";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";

function PcpApprove() {
  const { id } = useParams();
  const location = useLocation();
  const { data } = location.state || {};
  const { theme } = useContext(ThemeContext);
  const { showSidebar, accessToken } = useContext(AuthContext);
  const isMobile = useMediaQuery({ maxWidth: 1024 });
  const [wapu, setWapu] = useState(data?.isWapu || false);

  const [pcpDetail, setPcpDetail] = useState([]);

  const retrievePCPDetail = () => {
    axiosAuth
      .get(
        data?.lead?.orderType === "penjualan"
          ? `/api/pcp/details?pcpId=${data?.id}`
          : `/api/pcp/sewa/details?pcpId=${data?.id}`,
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            withCredentials: true,
            Authorization: `Bearer ${accessToken}`,
          },
        },
      )
      .then((res) => {
        setPcpDetail(res.data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    if (accessToken !== undefined && data?.id !== undefined)
      retrievePCPDetail();
  }, [accessToken, data?.id]);

  const numberFormat = (value) =>
    new Intl.NumberFormat("IN-ID", {
      style: "currency",
      currency: "IDR",
    }).format(value);

  const subTotalCost =
    (parseFloat(data?.overhead) || 0) +
    (parseFloat(data?.externalDirectLabor) || 0) +
    (parseFloat(data?.deliveryCost) || 0) +
    (parseFloat(data?.financialCost) || 0) +
    (parseFloat(data?.otherFinancialCost) || 0) +
    (parseFloat(data?.otherAllowance) || 0);

  const grossMargin =
    (parseFloat(data.salesTotal) || 0) - (parseFloat(data.purchasesTotal) || 0);

  const netMargin =
    (parseFloat(grossMargin) || 0) - (parseFloat(subTotalCost) || 0);

  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const totalHargaJual = pcpDetail.reduce(
    (total, item) => total + (item.subtotal || 0),
    0,
  );

  const [rowSelected, setRowSelected] = useState({});
  const [showDetailPcpSewa, setShowDetailPcpSewa] = useState(false);

  const handleShowDetailPcpSewa = (item) => {
    setShowDetailPcpSewa(true);
    setRowSelected(item);
  };

  useEffect(() => {
    if (data && data.isWapu !== undefined) {
      setWapu(data.isWapu);
    }
  }, [data]);

  const handleApprove = async (data) => {
    const result = await Swal.fire({
      title: "Approve PCP ini?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Approve",
      cancelButtonText: "Batalkan",
    });

    if (result.isConfirmed) {
      const dataPcp = {
        status: "approved",
      };

      try {
        const response = await axiosAuth.put(
          data?.lead?.orderType === "penjualan"
            ? `/api/pcp/${data?.id}`
            : `/api/pcp/sewa/${data?.id}`,
          dataPcp,
          {
            headers: {
              "Access-Control-Allow-Origin": "*",
              withCredentials: true,
              Authorization: `Bearer ${accessToken}`,
            },
          },
        );

        Swal.fire("Berhasil!", "PCP berhasil di Approved", "success");

        navigate("/pcp");
      } catch (err) {
        console.error(err);
        Swal.fire("Error", "Terjadi kesalahan saat mengapproved PCP!", "error");
      }
    } else {
      <></>;
    }
  };

  const handleDenied = async (data) => {
    const result = await Swal.fire({
      title: "Tolak PCP ini?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Tolak",
      cancelButtonText: "Batalkan",
    });

    if (result.isConfirmed) {
      const dataPcp = {
        status: "denied",
      };

      try {
        const response = await axiosAuth.put(
          data?.lead?.orderType === "penjualan"
            ? `/api/pcp/${data?.id}`
            : `/api/pcp/sewa/${data?.id}`,
          dataPcp,
          {
            headers: {
              "Access-Control-Allow-Origin": "*",
              withCredentials: true,
              Authorization: `Bearer ${accessToken}`,
            },
          },
        );

        Swal.fire("Berhasil!", "PCP telah di Tolak", "success");

        navigate("/pcp");
      } catch (err) {
        console.error(err);
        Swal.fire("Error", "Terjadi kesalahan saat menolak PCP!", "error");
      }
    } else {
      <></>;
    }
  };

  const formStyles = {
    label: {
      fontFamily: "Poppins-Medium",
      color: theme === "light" ? "#FFFFFF" : "#222222",
    },
    input: {
      color: theme === "light" ? "#FFFFFF" : "#222222",
      fontFamily: "Poppins-Regular",
      minHeight: "50px",
      borderColor: "#ced4da",
      background: theme === "light" ? "#212529" : "#FFFFFF",
    },
    inputQty: {
      color: theme === "light" ? "#FFFFFF" : "#222222",
      fontFamily: "Poppins-Regular",
      maxWidth: "90px",
      borderColor: "#ced4da",
      background: theme === "light" ? "#212529" : "#FFFFFF",
    },
    nettMargin: {
      fontFamily: "Poppins-Medium",
      color:
        netMargin <= 300000 ? "red" : theme === "light" ? "#FFFFFF" : "#222222",
      minHeight: "50px",
      borderColor: "#ced4da",
      background: theme === "light" ? "#212529" : "#FFFFFF",
    },
  };

  const [leadDetail, setLeadDetail] = useState();

  const retrieveLeadDetail = () => {
    axiosAuth
      .get(`/api/leads/${data?.lead?.id}`, {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          withCredentials: true,
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        setLeadDetail(res?.data?.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    if (accessToken !== undefined && data?.lead?.id !== undefined)
      retrieveLeadDetail();
  }, [accessToken, data?.lead?.id]);

  const [rowSelectedLead, setRowSelectedLead] = useState();
  const [showEditLead, setShowEditLead] = useState(false);
  const handleShowEditLead = (leadDetail) => {
    setShowEditLead(true);
    setRowSelectedLead(leadDetail);
  };

  const creditScore = data?.lead?.customer?.creditScore;

  const renderStars = (score) => {
    const totalStars = 5;
    const stars = [];

    for (let i = 1; i <= totalStars; i++) {
      if (i <= score) {
        stars.push(<AiFillStar key={i} color="#fcd34d" size={24} />); // filled star
      } else {
        stars.push(<AiOutlineStar key={i} color="#fcd34d" size={24} />); // empty star
      }
    }

    return stars;
  };

  const pcpDate = new Date(data?.lead.date);
  const day = String(pcpDate.getDate()).padStart(2, "0");
  const month = String(pcpDate.getMonth() + 1).padStart(2, "0");
  const year = pcpDate.getFullYear();
  const formattedDate = `${day}/${month}/${year}`;

  return (
    <div
      style={{
        overflowX: "hidden",
        maxWidth: "100vw",
        backgroundColor: theme === "light" ? "#121212" : "#FFFFFF",
        transition: "0.8s",
      }}
    >
      <SidebarComponent />
      <div
        id={theme === "light" ? "containerAppDark" : "containerAppLight"}
        style={{
          width: isMobile
            ? "100%"
            : `calc(100% - ${showSidebar ? "78px" : "190px"})`,
          marginLeft: isMobile ? "0px" : showSidebar ? "78px" : "190px",
          transition: "0.8s",
        }}
      >
        <div className={isMobile ? "ms-2" : "ms-3 me-3"}>
          <Row>
            <Col xs={6} lg={6} className="text-start">
              <Row>
                <Col>
                  <h5
                    className="pt-4"
                    style={{
                      fontFamily: "Poppins-Medium",
                      fontSize: isMobile ? "25px" : "38px",
                      color: theme === "light" ? "#FFFFFF" : "",
                      marginBottom: "0px",
                    }}
                  >
                    {data?.lead.noLead}
                  </h5>
                </Col>
                <Col>
                  <div className="pt-4">
                    <Button
                      id={
                        theme === "light"
                          ? "actionButtonModalDark"
                          : "actionButtonModalLight"
                      }
                      onClick={() => handleShowEditLead(leadDetail)}
                    >
                      Lihat
                    </Button>
                  </div>
                </Col>
              </Row>
              <p
                style={{
                  fontFamily: "Poppins-Regular",
                  fontSize: "18px",
                  color: theme === "light" ? "#FFFFFF" : "",
                  marginBottom: "0px",
                }}
              >
                Tanggal: {formattedDate}
              </p>
            </Col>
            <Col
              xs={6}
              lg={6}
              className={
                isMobile === false
                  ? "text-end my-auto"
                  : "text-end my-auto pt-4"
              }
            >
              <HeaderWeb />
            </Col>
          </Row>
        </div>
        <div className={isMobile ? "ms-1 mt-4" : "ms-3 mt-4"}>
          <Row>
            <Col xs={12} lg={4} className="mb-3">
              <Form.Label style={formStyles.label} htmlFor="customer">
                Customer
              </Form.Label>
              <Form.Control
                id="customer"
                type="text"
                defaultValue={data?.lead?.customer?.name || ""}
                readOnly
                style={formStyles.input}
              />
            </Col>
            <Col xs={12} lg={4} className="mb-3">
              <Form.Label style={formStyles.label} htmlFor="project">
                Nama Projek*
              </Form.Label>
              <Form.Control
                id="project"
                type="text"
                defaultValue={data?.projectName || ""}
                readOnly
                style={formStyles.input}
              />
            </Col>
            <Col xs={12} lg={3} className="mb-3">
              <Form.Label style={formStyles.label} htmlFor="request">
                Jenis Permintaan*
              </Form.Label>
              <Form.Control
                id="project"
                type="text"
                defaultValue={data?.lead.orderType || ""}
                readOnly
                style={formStyles.input}
              />
            </Col>
            <Col xs={12} lg={1} className="mb-3">
              <Form.Label style={formStyles.label}>Wapu</Form.Label>
              <Form.Check
                type="checkbox"
                id="default-checkbox"
                onChange={(e) => setWapu(e.target.checked)}
                checked={wapu}
                style={formStyles.label}
                disabled={pcpDetail.length !== 0}
              />
            </Col>
            <Col xs={12} lg={4} className="mb-3">
              <Form.Label style={formStyles.label} htmlFor="franco">
                Franco*
              </Form.Label>
              <Form.Control
                id="franco"
                type="text"
                defaultValue={data?.franco || ""}
                readOnly
                style={formStyles.input}
              />
            </Col>
            <Col xs={12} lg={4} className="mb-3">
              <Form.Label style={formStyles.label} htmlFor="status">
                Status Pcp
              </Form.Label>
              <Form.Control
                id="status"
                type="text"
                defaultValue={data?.status || ""}
                readOnly
                style={formStyles.input}
              />
            </Col>
            <Col xs={12} lg={4} className="mb-3">
              <Form.Label style={formStyles.label}>Credit Score</Form.Label>
              <div className="mt-2">{renderStars(creditScore)}</div>
            </Col>
            <Col xs={12} lg={4} className="mb-3">
              <Form.Group>
                <Form.Label style={formStyles.label} htmlFor="description">
                  Syarat dan ketentuan tambahan
                </Form.Label>
                <Form.Control
                  id="description"
                  as="textarea"
                  rows={3}
                  defaultValue={data?.description || ""}
                  readOnly
                  placeholder="Syarat dan ketentuan tambahan"
                  style={formStyles.input}
                />
              </Form.Group>
            </Col>
          </Row>
        </div>
        <div className={isMobile ? "ms-1 mt-4" : "ms-3 mt-4 me-3"}>
          <h3
            className="text-center"
            style={{
              fontFamily: "Poppins-Medium",
              color: theme === "light" ? "#FFFFFF" : "#222",
              fontSize: isMobile ? "25px" : "38px",
            }}
          >
            PCP Detail
          </h3>
          <Table
            className="mt-4"
            bordered
            responsive
            data-bs-theme={theme === "light" ? "dark" : "light"}
          >
            <thead>
              <tr
                style={{ fontFamily: "Poppins-Regular", textAlign: "center" }}
              >
                {data?.lead?.orderType === "penjualan" ? (
                  <></>
                ) : (
                  <th
                    style={{
                      textAlign: "center",
                    }}
                  >
                    Info
                  </th>
                )}
                <th
                  style={{
                    textAlign: "left",
                  }}
                >
                  Nama Produk
                </th>
                <th>Jenis Produk</th>
                {data?.lead?.orderType === "penjualan" ? (
                  <></>
                ) : (
                  <th>Durasi (Bulan)</th>
                )}
                <th
                  style={{
                    textAlign: "right",
                  }}
                >
                  Harga Beli
                </th>
                {data?.lead?.orderType === "penjualan" ? (
                  <th
                    style={{
                      textAlign: "right",
                    }}
                  >
                    Harga Jual
                  </th>
                ) : (
                  <th
                    style={{
                      textAlign: "right",
                    }}
                  >
                    Harga Sewa Perbulan
                  </th>
                )}
                <th>Qty</th>
                <th
                  style={{
                    textAlign: "right",
                  }}
                >
                  Sub Total
                </th>
                <th
                  style={{
                    textAlign: "center",
                  }}
                >
                  %
                </th>
              </tr>
            </thead>
            <tbody>
              {pcpDetail.map((item, index) => {
                const marginTotal =
                  ((parseFloat(item.sellingPrice || 0) -
                    parseFloat(item.buyingPrice || 0)) /
                    parseFloat(item.sellingPrice || 1)) *
                  100;

                const marginTotalSewa =
                  (parseFloat(item.nett) / parseFloat(item.subtotal)) * 100;

                const marginValidate = data?.isWapu
                  ? marginTotalSewa.toFixed(2) <= 26
                    ? false
                    : true
                  : marginTotalSewa.toFixed(2) <= 15
                    ? false
                    : true;

                return (
                  <tr
                    key={index}
                    style={{ fontFamily: "Poppins-Light", textAlign: "center" }}
                  >
                    {data?.lead?.orderType === "penjualan" ? (
                      <></>
                    ) : (
                      <td
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <Button
                          variant="btn"
                          onClick={() => handleShowDetailPcpSewa(item)}
                        >
                          <FaInfoCircle
                            size={20}
                            color={theme === "light" ? "#12B3ED" : "#006CB8"}
                          />
                        </Button>
                      </td>
                    )}
                    <td
                      style={{
                        textAlign: "left",
                        width: "350px",
                      }}
                    >
                      {item?.productName}
                    </td>
                    <td>{item?.category?.categoryName}</td>
                    {data?.lead?.orderType === "penjualan" ? (
                      <></>
                    ) : (
                      <td>{item.duration / 30}</td>
                    )}
                    <td
                      style={{
                        textAlign: "right",
                      }}
                    >
                      {numberFormat(item.buyingPrice)}
                    </td>
                    <td
                      style={{
                        textAlign: "right",
                      }}
                    >
                      {numberFormat(item.sellingPrice)}
                    </td>

                    <td>{item.quantity || 0}</td>
                    <td>{numberFormat(item.subtotal || 0)}</td>
                    {data?.lead?.orderType === "penjualan" ? (
                      <td
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <span
                          style={{
                            color: (() => {
                              const thresholdMargin = (() => {
                                switch (item?.category?.id) {
                                  case 1:
                                    return data.isWapu ? 16 : 10;
                                  case 2:
                                    return data.isWapu ? 31 : 20;
                                  case 3:
                                    return data.isWapu ? 41 : 30;
                                  default:
                                    return 0;
                                }
                              })();

                              return marginTotal <= thresholdMargin
                                ? "#FF0060"
                                : "#16C47F";
                            })(),
                          }}
                        >
                          {marginTotal.toFixed(2)
                            ? `${marginTotal.toFixed(2)}%`
                            : "0%"}
                        </span>
                      </td>
                    ) : (
                      <td
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <span
                          style={{
                            color:
                              marginValidate == false ? "#FF0060" : "#16C47F",
                          }}
                        >
                          {marginTotalSewa.toFixed(2)
                            ? `${marginTotalSewa.toFixed(2)}%`
                            : "0%"}
                        </span>
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </Table>
          {data?.lead?.orderType === "penjualan" ? (
            <div className="mt-5">
              <Row>
                <Col
                  xs={12}
                  lg={4}
                  className={isMobile ? "mb-5 text-start" : "text-start"}
                >
                  <Card data-bs-theme={theme === "light" ? "dark" : ""}>
                    <Card.Body>
                      <div>
                        <Form.Label
                          style={formStyles.label}
                          htmlFor="totalSelling"
                        >
                          Total Harga Jual
                        </Form.Label>
                        <Form.Control
                          id="totalSelling"
                          type="text"
                          className="mb-3"
                          value={numberFormat(totalHargaJual) || 0}
                          readOnly
                          style={formStyles.input}
                        />
                        <Form.Label style={formStyles.label} htmlFor="ppn">
                          PPN%
                        </Form.Label>
                        <Form.Control
                          id="ppn"
                          type="text"
                          className="mb-3"
                          defaultValue={data?.ppnPercentage || ""}
                          readOnly
                          style={formStyles.input}
                        />
                        <Form.Label style={formStyles.label} htmlFor="ppnValue">
                          PPN Amount
                        </Form.Label>
                        <Form.Control
                          id="ppnValue"
                          type="text"
                          className="mb-3"
                          defaultValue={numberFormat(data?.ppn) || ""}
                          readOnly
                          style={formStyles.input}
                        />
                        <Form.Label
                          style={formStyles.label}
                          htmlFor="grandTotal"
                        >
                          Grand Total
                        </Form.Label>
                        <Form.Control
                          id="grandTotal"
                          type="text"
                          className="mb-3"
                          defaultValue={numberFormat(data?.grandTotal) || ""}
                          readOnly
                          style={formStyles.input}
                        />
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col xs={12} lg={2}></Col>
                <Col xs={12} lg={6}>
                  <Card data-bs-theme={theme === "light" ? "dark" : ""}>
                    <Card.Body>
                      <div>
                        <Row>
                          <Col xs={12} lg={6}>
                            <Form.Label
                              style={formStyles.label}
                              htmlFor="overHead"
                            >
                              Over Head (3%)
                            </Form.Label>
                            <Form.Control
                              id="overHead"
                              type="text"
                              className="mb-3"
                              defaultValue={numberFormat(data?.overhead) || ""}
                              readOnly
                              style={formStyles.input}
                            />
                          </Col>
                          <Col xs={12} lg={6}>
                            <Form.Label
                              style={formStyles.label}
                              htmlFor="edlCost"
                            >
                              External Direct Labor Cost
                            </Form.Label>
                            <Form.Control
                              id="edlCost"
                              type="text"
                              className="mb-3"
                              defaultValue={
                                numberFormat(data?.externalDirectLabor) || ""
                              }
                              readOnly
                              required
                              style={formStyles.input}
                            />
                          </Col>
                          <Col xs={12} lg={6}>
                            <Form.Label
                              style={formStyles.label}
                              htmlFor="delivCost"
                            >
                              Delivery Cost
                            </Form.Label>
                            <Form.Control
                              id="delivCost"
                              type="text"
                              className="mb-3"
                              defaultValue={
                                numberFormat(data?.deliveryCost) || ""
                              }
                              readOnly
                              required
                              style={formStyles.input}
                            />
                          </Col>
                          <Col xs={12} lg={6}>
                            <Form.Label
                              style={formStyles.label}
                              htmlFor="financeCost"
                            >
                              Financial Cost
                            </Form.Label>
                            <Form.Control
                              id="financeCost"
                              type="text"
                              className="mb-3"
                              defaultValue={
                                numberFormat(data?.financialCost) || ""
                              }
                              readOnly
                              required
                              style={formStyles.input}
                            />
                          </Col>
                          <Col xs={12} lg={6}>
                            <Form.Label
                              style={formStyles.label}
                              htmlFor="otherFinanceCost"
                            >
                              Other Financial Cost
                            </Form.Label>
                            <Form.Control
                              id="otherFinanceCost"
                              type="text"
                              className="mb-3"
                              defaultValue={
                                numberFormat(data?.otherFinancialCost) || ""
                              }
                              readOnly
                              required
                              style={formStyles.input}
                            />
                          </Col>
                          <Col xs={12} lg={6}>
                            <Form.Label
                              style={formStyles.label}
                              htmlFor="otherAllow"
                            >
                              Other Allowance
                            </Form.Label>
                            <Form.Control
                              id="otherAllow"
                              type="text"
                              className="mb-3"
                              defaultValue={
                                numberFormat(data?.otherAllowance) || ""
                              }
                              readOnly
                              required
                              style={formStyles.input}
                            />
                          </Col>
                          <Col xs={12} lg={6}>
                            <Form.Label
                              style={formStyles.label}
                              htmlFor="subTotalCost"
                            >
                              Sub Total Cost
                            </Form.Label>
                            <Form.Control
                              id="subTotalCost"
                              type="text"
                              className="mb-3"
                              value={
                                numberFormat(subTotalCost) || numberFormat(0)
                              }
                              readOnly
                              style={formStyles.input}
                            />
                          </Col>
                          <Col xs={12} lg={6}>
                            <Form.Label
                              style={formStyles.label}
                              htmlFor="netMargin"
                            >
                              Net Margin
                            </Form.Label>
                            <Form.Control
                              id="netMargin"
                              type="text"
                              className="mb-3"
                              value={numberFormat(netMargin) || numberFormat(0)}
                              readOnly
                              style={formStyles.nettMargin}
                            />
                          </Col>
                        </Row>
                      </div>
                    </Card.Body>
                  </Card>
                  <div className="text-end mt-4 mb-4">
                    {data?.status === "pending" ? (
                      <>
                        <Button
                          variant="btn"
                          id={
                            theme === "light"
                              ? "actionButtonModalDark"
                              : "actionButtonModalLight"
                          }
                          type="submit"
                          onClick={() => handleApprove(data)}
                        >
                          Approve
                        </Button>
                        <Button
                          variant="btn"
                          type="submit"
                          className="ms-3"
                          style={{
                            backgroundColor: "#FF0060",
                            fontFamily: "Poppins-Regular",
                            color: "white",
                            minHeight: "45px",
                            border: "none",
                          }}
                          onClick={() => handleDenied(data)}
                        >
                          Tolak
                        </Button>
                      </>
                    ) : (
                      <></>
                    )}
                    <Button
                      variant="secondary"
                      className="ms-3"
                      onClick={handleBack}
                      style={{
                        fontFamily: "Poppins-Regular",
                        minHeight: "45px",
                      }}
                    >
                      Kembali
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          ) : (
            <div className="mt-5">
              <Row>
                <Col xs={12} lg={6} className="text-start"></Col>
                <Col xs={12} lg={2}></Col>
                <Col xs={12} lg={4}>
                  <Card data-bs-theme={theme === "light" ? "dark" : ""}>
                    <Card.Body>
                      <div>
                        <Form.Label
                          style={formStyles.label}
                          htmlFor="totalSelling"
                        >
                          Total Harga Jual
                        </Form.Label>
                        <Form.Control
                          id="totalSelling"
                          type="text"
                          className="mb-3"
                          value={numberFormat(totalHargaJual) || 0}
                          readOnly
                          style={formStyles.input}
                        />
                        <Form.Label style={formStyles.label} htmlFor="ppn">
                          PPN%
                        </Form.Label>
                        <Form.Control
                          id="ppn"
                          type="text"
                          className="mb-3"
                          defaultValue={data?.ppnPercentage || ""}
                          readOnly
                          style={formStyles.input}
                        />
                        <Form.Label style={formStyles.label} htmlFor="ppnValue">
                          PPN Amount
                        </Form.Label>
                        <Form.Control
                          id="ppnValue"
                          type="text"
                          className="mb-3"
                          defaultValue={numberFormat(data?.ppn) || ""}
                          readOnly
                          style={formStyles.input}
                        />
                        <Form.Label
                          style={formStyles.label}
                          htmlFor="grandTotal"
                        >
                          Grand Total
                        </Form.Label>
                        <Form.Control
                          id="grandTotal"
                          type="text"
                          className="mb-3"
                          defaultValue={numberFormat(data?.grandTotal) || ""}
                          readOnly
                          style={formStyles.input}
                        />
                      </div>
                    </Card.Body>
                  </Card>
                  <div className="text-end mt-4 mb-4">
                    {data?.status === "pending" ? (
                      <>
                        <Button
                          variant="btn"
                          id={
                            theme === "light"
                              ? "actionButtonModalDark"
                              : "actionButtonModalLight"
                          }
                          type="submit"
                          onClick={() => handleApprove(data)}
                        >
                          Approve
                        </Button>
                        <Button
                          variant="btn"
                          type="submit"
                          className="ms-3"
                          style={{
                            backgroundColor: "#FF0060",
                            fontFamily: "Poppins-Regular",
                            color: "white",
                            minHeight: "45px",
                            border: "none",
                          }}
                          onClick={() => handleDenied(data)}
                        >
                          Tolak
                        </Button>
                      </>
                    ) : (
                      <></>
                    )}
                    <Button
                      variant="secondary"
                      className="ms-3"
                      onClick={handleBack}
                      style={{
                        fontFamily: "Poppins-Regular",
                        minHeight: "45px",
                      }}
                    >
                      Kembali
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          )}
        </div>
      </div>
      <ModalDetailPcpSewa
        retrievePCPDetail={retrievePCPDetail}
        rowSelected={rowSelected}
        showDetailPcpSewa={showDetailPcpSewa}
        setShowDetailPcpSewa={setShowDetailPcpSewa}
      />
      <ModalUbahLead
        rowSelected={rowSelectedLead}
        showEditLead={showEditLead}
        setShowEditLead={setShowEditLead}
        retrieveLead={null}
        accessToken={accessToken}
      />
    </div>
  );
}

export default PcpApprove;
